import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { HttpMethods } from '@cbre/http';
import { Dictionary } from '@shared/models/generic-dictionary';
import { IOption } from '@shared/models/icommons.model';
import { Observable } from 'rxjs';
import { DefaultSelectionValue, InputProps, FilterInputType } from './input-props';

import { LookupRefService } from '@shared/services/lookup-ref.service';

type FiltersDictionary = Dictionary<AbstractControl>;

@Injectable({
  providedIn: 'root',
})
export class SimpleFormGroupService {
  constructor(
    private http: HttpMethods,
    private lookupRefServices: LookupRefService
  ) {}

  makeGroup = <T = DefaultSelectionValue>(inputProps: InputProps<T>[]): FiltersDictionary =>
    inputProps.reduce((fb, prop) => ({ ...fb, [prop.field]: this.#getControlByType<T>(prop) }), {});

  #getControlByType = <T>(prop: InputProps<T>) =>
    prop.type === FilterInputType.Range
      ? this.#makeRangeControlType(prop)
      : new UntypedFormControl(prop.value ?? '', prop.controlOptions);

  #makeRangeControlType = <T>(prop: InputProps<T>) => {
    const from = new UntypedFormControl(prop.value?.['from'] ?? null);
    const to = new UntypedFormControl(prop.value?.['to'] ?? null);
    return new UntypedFormGroup({ from, to });
  };

  /**
   * Get submarkets catalog.
   */
  getGeoMarkets(type: string, key: number): Observable<IOption[]> {
    const uri = `/geo/${type}/${key}`;
    return this.http.httpGet(uri) as Observable<IOption[]>;
  }

  /**
   * Get Markets.
   */
  getMarkets(request: any): Observable<IOption[]> {
    return this.lookupRefServices.loadDataFor(
      `POST:/users/:userId/geo/markets?all=false`,
      false,
      true,
      request
    ) as Observable<IOption[]>;
  }
}
